import { Container, Title, Text } from "@mantine/core";
import { PatientSelectorDemo } from "../components/dashboard/PatientSelectorDemo";

export default function PatientSelectorTest() {
  return (
    <Container size="lg" py="xl">
      <div className="space-y-6">
        <div>
          <Title order={1}>Patient Selector Test Page</Title>
          <Text color="dimmed" size="lg" mt={8}>
            Test and validate the enhanced patient selector component
          </Text>
        </div>

        <PatientSelectorDemo />
      </div>
    </Container>
  );
}
